export enum FeatureFlag {
	ENABLE_WEBVIEWER_MODIFICATIONS = "enableWebviewerModifications",
	ENABLE_WEBVIEWER_MODIFICATIONS_CREATION = "enableWebviewerModificationsCreation",
	ENABLE_WEBVIEWER_MODIFICATIONS_SETUP_CORRECTION = "enableWebviewerModificationsSetupCorrection",
	ENABLE_ETRACKER = "enableEtracker",
}

/**
 * Interface for feature flags configuration
 * Add new feature flags here as boolean properties
 */
export interface FeatureFlags {
	[FeatureFlag.ENABLE_WEBVIEWER_MODIFICATIONS]?: boolean;
	[FeatureFlag.ENABLE_WEBVIEWER_MODIFICATIONS_CREATION]?: boolean;
	[FeatureFlag.ENABLE_WEBVIEWER_MODIFICATIONS_SETUP_CORRECTION]?: boolean;
	[FeatureFlag.ENABLE_ETRACKER]?: boolean;
	[key: string]: boolean;
}

/**
 * Default feature flags - all disabled by default
 * Individual environments should override these values
 */
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {};
